
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import WhyEducator from './components/WhyEducator';
import ProgramOverview from './components/ProgramOverview';
import CertificationDetails from './components/CertificationDetails';
import SupportResources from './components/SupportResources';
import ApplySection from './components/ApplySection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <HeroSection />
      <WhyEducator />
      <ProgramOverview />
      <CertificationDetails />
      <SupportResources />
      <ApplySection />
      <ContactSection />
      <Footer />
    </div>
  );
}
